module.exports = {
    Admin: 'adm',
    User: 'user',
    Tcs: 'tcs',
    Support: 'support'
}